import React from "react";
import { Link } from "react-router-dom";
import "./Allcatforpost.css";
const Allcatforpostads = () => {
  return (
    <div>
      <h2
        style={{ textAlign: "center", fontFamily: "times", fontSize: "34px" }}
      >
        <ins>Select Your Category</ins>
      </h2>
      <div className="allcatpost  mb-2">
        <div className="catim">
          <Link
            to="/add-real/RealEstate"
            title="Category RealEstates"
            className="mt-3"
          >
            <img
              alt="imag"
              src="https://img.freepik.com/premium-vector/city-district-architecture-building-design-vector-illustration-house-construction-town-urban-graphic-landscape-concept-cartoon-stree-outdoor_169479-2449.jpg?w=740"

              className="categoryHover"
            />
            <p className="text-center fs-14 mb-0">Real Estate</p>
          </Link>
        </div>
        <div className="catim">
          <Link to="/add-product/Furniture" title="Category furniture" className="mt-3">
            <img
              alt="imag"
              src="https://img.freepik.com/free-vector/sofa-concept-illustration_114360-21655.jpg?w=740&t=st=1699275561~exp=1699276161~hmac=1e5d19878b368ecde4b7a50d2b7a0d230562e533f2a16be51e8014cc0a39878c"
              className="categoryHover"
            />
            <p className="text-center fs-14 mb-0">Furniture</p>
          </Link>
        </div>
        <div className="catim">
          <div>
            <Link
              to="/add-product/Electronics"
              title="Category Electronics"
              className="mt-3"
            >
              <img
                alt="imag"
                src="https://img.freepik.com/premium-vector/cute-sad-conditioning-character_464314-1344.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Electronics</p>
            </Link>
          </div>
        </div>
        <div className="catimmm">
          {" "}
          <div>
            <Link to="/add-product/Mobiles" title="Category Mobiles" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/phone_78370-560.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Mobiles</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          <div>
            <Link to="/add-product/Pets" title="Category Pets" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/premium-vector/cute-3d-puppy-style-photorealistic_873674-428.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Pets</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          <div>
            <Link to="/add-product/Cars" title="Category Cars" className="mt-3">
              <img
                alt="imag"
                src="https://media.istockphoto.com/id/1290543311/vector/realistic-blue-sedan-car-side-view.jpg?s=1024x1024&w=is&k=20&c=IUEW2_moQnp2OCQ6XEW0HQ2oqSc1Gnh09ICBuE7oCCg="
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Cars</p>
            </Link>
          </div>
        </div>
        <div className="catim" >
          <div>
            <Link
              to="/add-job/Jobs"
              title="Category Jobs"
              className="mt-3">
              <img
                alt="imag"
                src="data:image/png;base64,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"
                className="categoryHover"
              />
              <p className="text-center fs-14  mb-0">Jobs</p>
            </Link>
          </div>
        </div>

        <div className="catim">
          <div>
            <Link to="/add-product/Bikes" title="Category Bikes" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/premium-vector/blue-sport-race-motorbike-vector_7496-201.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Bikes</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          {" "}
          <div>
            <Link
              to="/add-services/Services"
              // to="/updatingSoon"
              title="Category Services"
              className="mt-3"
            >
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/flat-customer-service-week-illustration_23-2149644201.jpg?w=740&t=st=1699276712~exp=1699277312~hmac=c64c83a3d6f8bdd09773156e558b9035feaf7d8dfc9c78c8ca0d408b5fc5288b"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Services</p>
            </Link>
          </div>
        </div>

        <div className="catim">
          <div>
            <Link to="/add-edu/Education" title="Category Education" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/premium-vector/getting-graduate-degree-semi-flat-color-vector-object_151150-9170.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Education</p>
            </Link>
          </div>
        </div>

        <div className="catim">
          <div>
            <Link to="/add-sci/ScienceAndTech" title="Category ScienceAndTech" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/hand-drawn-innovation-concept-with-ideas_23-2149153088.jpg?t=st=1734418853~exp=1734422453~hmac=e35e1a94897e6e5b621174063a2e334a46e11adaf49438f2c11a09c9808d89a2&w=740"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Science & Tech</p>
            </Link>
          </div>
        </div>
        {/* <div className="catim">
          <div>
            <Link to="/add-FoodsAndBeverages"  title="Category FoodsAndBeverages" className="mt-3">
              </Link>
              </div>
              </div> */}

        <div className="catim">
          <div>
            <Link to="/add-FoodsAndBeverages/FoodsAndBeverages" title="Category FoodsAndBeverages" className="mt-3">
              <img
                alt="imag"
                src="https://www.pngall.com/wp-content/uploads/8/Cuisine-PNG-Free-Download.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Foods & Beverages</p>
            </Link>
          </div>
        </div>

        <div className="catim">
          <div>
            <Link to="/add-travel/TravelAndAdventure" title="Category TravelAndAdventure" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/vacation-holidays-background-with-realistic-globe-suitcase-photo-camera_1284-10476.jpg?t=st=1735455070~exp=1735458670~hmac=87dcc0a7b1551965553799be40db09b3ec697f3f490216cd09609a8d79e211b0&w=740"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Travel & Adv</p>
            </Link>
          </div>
        </div>
        {/* <div className="catim">
          <div>
            <Link to="/add-hobbies"  title=" Category Hobbies" className="mt-3">
              </Link>
              </div>
              </div> */}

        <div className="catim">
          <div>

            <Link to="/add-BooksSportsHobbies/BooksSportsHobbies" title=" Category BooksSportsHobbies" className="mt-3">
              <img
                alt="imag"
                src="https://i.pinimg.com/236x/cf/7c/63/cf7c63d66a1ebe54c2953e3246cd0268.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">BooksSportsHobbies</p>
            </Link>


          </div>
        </div>

        <div className="catim">
          <div>

            <Link to="/add-EcoFriendlyProducts/EcoFriendlyProducts" title=" Category EcoFriendlyProducts" className="mt-3">
              <img
                alt="imag"
                src='https://png.pngtree.com/png-vector/20220730/ourmid/pngtree-circle-eco-friendly-logo-symbol-png-image_6093131.png'
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Eco-Friendly Products</p>
            </Link>
          </div>
        </div>

        <div className="catim">
          <div>

            <Link to="/add-MusicalInstruments/MusicalInstruments" title=" Category MusicalInstruments" className="mt-3">
              <img
                alt="imag"
                src='https://thumbs.dreamstime.com/b/musical-instruments-orchestra-collage-music-38504603.jpg'
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Musical Instruments</p>
            </Link>

          </div>
        </div>

        <div className="catim">
          <div>
            <Link to="/add-tech/TechGadgets" title="Category TechGadgets" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/laptop-smartphone-headphone-cartoon-icon-illustration-business-technology-icon-concept-isolated-flat-cartoon-style_138676-2139.jpg?t=st=1735479905~exp=1735483505~hmac=020801a578f54566558db1e3c398fc1c97749df2e4942349198e395c58f4bc5f&w=740"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Tech Gadgets</p>
            </Link>
          </div>
        </div>
        {/* <div className="catim">
          <div>
            <Link to="/add-AddHealthFitness"  title="Category AddHealthFitness" className="mt-3">
              </Link>
              
          </div>
        </div> */}

        <div className="catim">
          <div>

            <Link to="/add-HealthFitness/HealthFitness" title="Category HealthFitness" className="mt-3">
              <img
                alt="imag"
                src="https://png.pngtree.com/png-vector/20220409/ourmid/pngtree-gym-gymnasium-body-building-exercise-training-fitness-workout-png-image_4503753.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Health & Fitness</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          <div>
            <Link to="/add-childbooks/ChildrenBooks" title="Category ChildrenBooks" className="mt-3">
              <img
                alt="imag"
                src="https://img.freepik.com/free-vector/student-girl-with-reading-book-hands_25030-39051.jpg?t=st=1736084798~exp=1736088398~hmac=7da422fe7ac834c6ceee60bee07f8c617c4d9e467c65a9e9deea49beee2a7af0&w=740"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Children's Books</p>
            </Link>


          </div>
        </div>
        <div className="catim">
          <div>
            {/* <Link to="/add-AddBooksAndMedia"  title="Category AddBooksAndMedia" className="mt-3"> */}
            <Link to="/add-BooksAndMedia/BooksAndMedia" title="Category BooksAndMedia" className="mt-3">
              <img
                alt="imag"
                src="https://png.pngtree.com/png-vector/20240325/ourmid/pngtree-cartoon-how-to-sell-book-png-image_12196643.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Books & Media</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          <div>
            <Link to="/add-fashion/Fashion" title="Category Fashion" className="mt-3">
              <img
                alt="imag"
                src="https://cdn-icons-png.flaticon.com/512/5934/5934507.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Fashion</p>
            </Link>
          </div>
        </div>
        <div className="catim">
          <div>
            <Link to="/add-CommercialVehicles/CommercialVehicles" title="Category CommercialVehicles" className="mt-3">
              <img
                alt="imag"
                src="https://media.istockphoto.com/id/516503046/vector/vector-truck-spares-concept.jpg?s=612x612&w=0&k=20&c=RyWW1-iTPy2zFKFLZq_NqFUULQ0WFJG6DAzuFOC3FvE="
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">commercial vehicles <br /> and spares</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-ToysAndGames/ToysAndGames" title="Category ToysAndGames" className="mt-3">
              <img
                alt="imag"
                src="https://cdn-icons-png.flaticon.com/512/7058/7058443.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Toys & Games</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-HealthAndBeauty/HealthAndBeauty" title="Category Health and Beauty" className="mt-3">
              <img
                alt="imag"
                src="https://png.pngtree.com/png-vector/20220708/ourmid/pngtree-beauty-care-logo-png-image_5773807.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Health & Beauty</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-FarmingAndGardening/FarmingAndGardening" title="Category Farming and Gardening" className="mt-3">
              <img
                alt="imag"
                src="https://cdn-icons-png.freepik.com/512/4388/4388950.png"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Farming & Gardening</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-PhotographyEquipment/PhotographyEquipment" title="Category Photography Equipment" className="mt-3">
              <img
                alt="image"
                src="https://img.freepik.com/premium-photo/camera-cartoon-photography-icon-cartoon-camera-photography-equipment-picturetaking-photo-illus_980716-50667.jpg?w=360"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Photography<br />Equipments</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-GiftsAndFlowers/GiftsAndFlowers" title="Category GiftsAndFlowers" className="mt-3">
              <img
                alt="image"
                src="https://www.arabianflora.com/blog/wp-content/uploads/2022/04/Importance-of-Sending-Flowers-and-Gifts-on-Ramadan1-1024x766.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Gifts And Flowers</p>
            </Link>
          </div>
        </div>
        <div class="catim">
          <div>
            <Link to="/add-SecurityAndSafety/SecurityAndSafety" title="Category SecurityAndSafety" className="mt-3">
              <img
                alt="image"
                src="https://th.bing.com/th/id/OIP.HZHcUvS5iHyL6LzFRaqCOwHaGD?rs=1&pid=ImgDetMain"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Security And Safety</p>
            </Link>
          </div>
        </div>
        
        <div class="catim">
          <div>
            <Link to="/add-CollectiblesAndMemorabiliaProduct/CollectiblesAndMemorabiliaProduct" title="Category CollectiblesAndMemorabiliaProduct" className="mt-3">
              <img
                alt="image"
                src="https://th.bing.com/th/id/OIP.n4b8v4igskEaHOyuLSqVBQHaE8?rs=1&pid=ImgDetMain"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Collectibles Product</p>
            </Link>
          </div>
        </div>
        
        <div class="catim">
          <div>
            <Link to="/add-LocalServices/LocalServices" title="Category LocalServices" className="mt-3">
              <img
                alt="image"
                src="https://thumbs.dreamstime.com/z/local-service-rubber-stamp-text-local-service-inside-illustration-109190542.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Local Services</p>
            </Link>
          </div>
        </div>

        {/* <div className="catim">
          <div>
            <Link to="/add-product/Others" title="Category Others" className="mt-3">
              <img
                alt="imag"
                src="https://icon-library.com/images/category-icon-png/category-icon-png-2.jpg"
                className="categoryHover"
              />
              <p className="text-center fs-14 mb-0">Others</p>
            </Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Allcatforpostads;
